import { ApiFunc, getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const conference: ApiFunc<`${typeof API.CONFERENCE}{id}`, 'get'> = data =>
  instance.get(`${API.CONFERENCE}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const conferenceCreate: ApiFunc<`${typeof API.CONFERENCE}`, 'post'> = data => instance.post(API.CONFERENCE, data)

export const conferenceAll: ApiFunc<`${typeof API.CONFERENCE_ALL}`, 'get'> = data =>
  instance.get(API.CONFERENCE_ALL, { params: data })

export const conferenceAllFilter: ApiFunc<`${typeof API.CONFERENCE_ALL_FILTER}`, 'get'> = data =>
  instance.get(API.CONFERENCE_ALL_FILTER, { params: data })

export const conferenceArticleList: ApiFunc<`${typeof API.CONFERENCE_ARTICLE_LIST}`, 'get'> = data =>
  instance.get(API.CONFERENCE_ARTICLE_LIST, { params: data })

export const conferenceArticleAll: ApiFunc<`${typeof API.CONFERENCE_ARTICLE_ALL}`, 'get'> = data =>
  instance.get(API.CONFERENCE_ARTICLE_ALL, { params: data })

export const conferenceMagazineArticle: ApiFunc<`${typeof API.CONFERENCE_MAGAZINE_ARTICLE}`, 'get'> = data =>
  instance.get(API.CONFERENCE_MAGAZINE_ARTICLE, { params: data })

export const conferenceCategoryAll: ApiFunc<`${typeof API.CONFERENCE_CATEGORY_ALL}`, 'get'> = data =>
  instance.get(API.CONFERENCE_CATEGORY_ALL, { params: data })

export const conferenceArticle: ApiFunc<`${typeof API.CONFERENCE_ARTICLE}{id}`, 'get'> = data =>
  instance.get(`${API.CONFERENCE_ARTICLE}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const conferenceArticleStep: ApiFunc<`${typeof API.CONFERENCE_ARTICLE_STEP}`, 'post'> = data =>
  instance.post(API.CONFERENCE_ARTICLE_STEP, data)

export const conferenceArticleProof: ApiFunc<`${typeof API.CONFERENCE_ARTICLE_PROOF}`, 'post'> = data =>
  instance.post(API.CONFERENCE_ARTICLE_PROOF, data)
